import React, { useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import {
  // append,
  // concat,
  // includes,
  // join,
  mergeRight,
  // uniq,
  // without,
} from "ramda";
import { useSelected } from "../OrganizeProvider";
import { useContentByStatus } from "../../creatorServices";
import { useSearchQuery } from "../../common/use-searchQuery";
// import { useOrganizedContentGroups } from "../../creatorServices";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faAngleDown } from "@fortawesome/pro-regular-svg-icons";
import { isBlank, notBlank } from "../../../util/ext";
import { useLocation } from "react-router-dom";
// import { sortByLastUpdated, deduplicate } from "../../../util/mediaUtil";

// import Checkbox from "@mui/material/Checkbox";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";

// import ContentGroupsPanel from "./ContentGroupsPanel";
import ContentGroupFilesBrowser from "./ContentGroupFilesBrowser";
import ContentSourcesAutocomplete from "../common/ContentSourcesAutocomplete";
// import OrganizeButton from "../common/OrganizeButton";
import OrganizeContentGroupsBrowser from "./OrganizeContentGroupsBrowser";
import RealTimeSearchBar from "../../common/RealTimeSearchBar";

const useStyles = makeStyles(theme => ({
  endIcon: {
    color: theme.palette.primary.brandPrimary,
  },

  header: {
    fontSize: "2rem",
    fontWeight: 700,
    lineHeight: "2.8rem",
  },
}));

// const initialContentGroupsState = {
//   appliedQuery: "",
//   page: 0,
//   limit: 20,
//   orderBy: "auditUpdated",
//   orderDirection: "desc",
//   hasParent: true,
//   mediaTypes: ["anthology", "collection"],
// };

const initialContentSearchState = {
  appliedQuery: "",
  page: 0,
  limit: 10,
  orderBy: "media.auditAdded",
  orderDirection: "desc",
  q: "",
  status: "approved",
  source: {
    projectKey: "",
    projectName: "",
  },
};

const getInitialContentSearchState = initialState =>
  mergeRight(initialContentSearchState, initialState);

const ContentGroupsBrowser = props => {
  const { SnackAlertHandler, view } = props;
  // const { showAlert } = SnackAlertHandler;
  const { selectedContent } = useSelected();
  const classes = useStyles();
  const location = useLocation();

  //-- Manage Menu States
  // const [anchorElType, setAnchorElType] = useState(null);
  // const handleClick = event => {
  //   event.stopPropagation();
  //   setAnchorElType(event.currentTarget);
  // };

  // const handleTypeClose = event => {
  //   event.stopPropagation();
  //   setAnchorElType(null);
  // };

  // const onTypeClick = type => event => {
  //   event.stopPropagation();

  //   const newTypes = event.target.checked
  //     ? uniq(append(type, initialContentGroupsState.mediaTypes))
  //     : without(type, initialContentGroupsState.mediaTypes);

  //   contentGroupsQuery.handleUpdateMediaTypes(newTypes);
  // };

  //-- Manage Content Groups Search State
  // const contentGroupsQuery = useSearchQuery(initialContentGroupsState);
  // const [contentGroupsQueryState, setContentGroupsQueryState] = useState({
  //   ...initialContentGroupsState,
  //   limit: initialContentGroupsState.limit,
  //   offset: contentGroupsQuery.state.limit * contentGroupsQuery.state.page,
  //   sort: `${contentGroupsQuery.state.orderBy} ${contentGroupsQuery.state.orderDirection}`,
  //   mediaType: join(",", contentGroupsQuery.state.mediaTypes),
  // });

  // useEffect(() => {
  //   const { appliedQuery, limit, page } = contentGroupsQuery.state;
  //   const sort =
  //     contentGroupsQuery.state.orderBy === null
  //       ? `${initialContentGroupsState.orderBy} ${initialContentGroupsState.orderDirection}`
  //       : `${contentGroupsQuery.state.orderBy} ${contentGroupsQuery.state.orderDirection}`;

  //   setContentGroupsQueryState({
  //     limit,
  //     offset: limit * page,
  //     sort,
  //     mediaType: join(",", contentGroupsQuery.state.mediaTypes),
  //     q: appliedQuery,
  //   });
  // }, [contentGroupsQuery.state]);
  // const contentGroupsResults = useOrganizedContentGroups(
  //   contentGroupsQueryState,
  // );

  // const [contentGroups, setContentGroups] = useState([]);
  // useEffect(() => {
  //   if (contentGroupsResults.isSuccess) {
  //     setContentGroups(prev => {
  //       const previous = contentGroupsQuery.state.page === 0 ? [] : prev;
  //       const groups = concat(previous, contentGroupsResults.data.contents);
  //       return sortByLastUpdated(deduplicate(groups));
  //     });
  //   }
  // }, [
  //   contentGroupsQuery.state.page,
  //   contentGroupsResults.isSuccess,
  //   contentGroupsResults.data,
  // ]);

  // Manage Content Query State
  const initialContentState = getInitialContentSearchState(
    notBlank(location.state) ? location.state.searchState : {},
  );
  const contentQuery = useSearchQuery(initialContentState);
  const [contentQueryState, setContentQueryState] = useState({
    ...initialContentState,
    offset: contentQuery.state.limit * contentQuery.state.page,
    sort: `${contentQuery.state.orderBy} ${contentQuery.state.orderDirection}`,
    source: contentQuery.state.source,
  });
  useEffect(() => {
    const { appliedQuery, limit, page } = contentQuery.state;
    const sort = isBlank(contentQuery.state.orderBy)
      ? `${initialContentState.orderBy} ${initialContentState.orderDirection}`
      : `${contentQuery.state.orderBy} ${contentQuery.state.orderDirection}`;

    setContentQueryState({
      ...contentQuery.state,
      sort,
      offset: limit * page,
      q: appliedQuery,
    });
  }, [
    contentQuery.state,
    initialContentState.orderBy,
    initialContentState.orderDirection,
  ]);

  const contentResults = useContentByStatus({
    ...contentQueryState,
    source: contentQueryState.source.projectKey,
  });

  //-- Loading State
  const [contentLoading, setContentLoading] = useState(false);
  useEffect(() => {
    setContentLoading(contentResults.isLoading);
  }, [contentResults.isLoading]);

  return (
    <OrganizeContentGroupsBrowser
      view={view}
      header={
        <Typography variant="h2" className={classes.header}>
          Organized
        </Typography>
      }
      // contentGroupsPanel={
      //   <ContentGroupsPanel
      //     title="Content Groups"
      //     totalGroups={
      //       contentGroupsResults.isSuccess
      //         ? contentGroupsResults.data.count
      //         : "-"
      //     }
      //     loading={contentGroupsResults.isLoading}
      //     hasMore={
      //       contentGroupsResults.isSuccess
      //         ? contentGroupsResults.data.hasMore
      //         : null
      //     }
      //     types={contentGroupsQuery.state.mediaTypes}
      //     view={view}
      //     showAlert={showAlert}
      //     contentGroups={contentGroups}
      //     handleContentGroupsPageChange={() =>
      //       contentGroupsQuery.handleUpdatePage(
      //         contentGroupsQuery.state.page + 1,
      //       )
      //     }
      //     searchBar={
      //       <RealTimeSearchBar
      //         searchBarEnd
      //         query={contentGroupsQuery.state.appliedQuery}
      //         onQueryChange={contentGroupsQuery.handleUpdateQuery}
      //       />
      //     }
      //     filterMenu={
      //       <Fragment>
      //         <OrganizeButton
      //           onClick={handleClick}
      //           variant="outlined"
      //           color="primary"
      //           endIcon={<FontAwesomeIcon icon={faAngleDown} />}
      //           classes={{ endIcon: classes.endIcon }}
      //         >
      //           Type
      //         </OrganizeButton>
      //         <Menu
      //           id="filter-groups-by-type-menu"
      //           anchorEl={anchorElType}
      //           keepMounted
      //           open={Boolean(anchorElType)}
      //           onClose={handleTypeClose}
      //           anchorOrigin={{
      //             vertical: "bottom",
      //             horizontal: "right",
      //           }}
      //           transformOrigin={{
      //             vertical: "top",
      //             horizontal: "right",
      //           }}
      //
      //         >
      //           <MenuItem onClick={event => event.stopPropagation()}>
      //             <FormControlLabel
      //               label="Anthology"
      //               control={
      //                 <Checkbox
      //                   name={"anthology"}
      //                   checked={includes(
      //                     "anthology",
      //                     contentGroupsQuery.state.mediaTypes,
      //                   )}
      //                   onChange={onTypeClick("anthology")}
      //                   color="primary"
      //                 />
      //               }
      //             />
      //           </MenuItem>

      //           <MenuItem onClick={event => event.stopPropagation()}>
      //             <FormControlLabel
      //               label="Collection"
      //               control={
      //                 <Checkbox
      //                   name={"collection"}
      //                   checked={includes(
      //                     "collection",
      //                     contentGroupsQuery.state.mediaTypes,
      //                   )}
      //                   onChange={onTypeClick("collection")}
      //                   color="primary"
      //                 />
      //               }
      //             />
      //           </MenuItem>
      //         </Menu>
      //       </Fragment>
      //     }
      //   />
      // }
      filesPanel={
        <ContentGroupFilesBrowser
          searchState={contentQueryState}
          sourceFilter={contentQuery.state.source}
          searchBar={
            <RealTimeSearchBar
              searchBarEnd
              query={contentQuery.state.appliedQuery}
              onQueryChange={contentQuery.handleUpdateQuery}
            />
          }
          filterMenu={
            <ContentSourcesAutocomplete
              setSource={contentQuery.handleUpdateSource}
              source={contentQuery.state.source}
            />
          }
          view={view}
          loading={contentLoading}
          setLoading={setContentLoading}
          content={contentResults.isSuccess ? contentResults.data.contents : []}
          total={contentResults.isSuccess ? contentResults.data.count : "-"}
          page={contentQuery.state.page}
          handlePageChange={(event, newPage) =>
            contentQuery.handleUpdatePage(newPage)
          }
          handleSortChange={contentQuery.handleUpdateSort}
          order={contentQuery.state.orderDirection}
          orderBy={contentQuery.state.orderBy}
          onRowsPerPageChange={contentQuery.handleUpdateLimit}
          rowsPerPage={contentQuery.state.limit}
          selectedContent={selectedContent}
          SnackAlertHandler={SnackAlertHandler}
        />
      }
    />
  );
};

export default ContentGroupsBrowser;
